const userSelector = (state) => state.user;

const currentUserIDSelector = ({ user }) => user.user.id;

const isAdminSelector = ({ user }) => user.user.isAdmin;

export { userSelector, currentUserIDSelector, isAdminSelector };
